import { type GivingContentObjectDetail, createGivingContentObjectDetail } from 'models';
import { type UseQueryOptions, useQuery } from 'query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { getInternalGivingDetail } from '../services';
import { getGivingDetailQueryKey } from './keys';

type P = {
  id: string;
  options?: Partial<UseQueryOptions<GivingContentObjectDetail, ApiClientResponseError<ResponseErrorDataObject>>>;
};

export const useGivingDetailQuery = ({ id, options }: P) =>
  useQuery<GivingContentObjectDetail>({
    async queryFn() {
      const { data } = await getInternalGivingDetail({ routeParams: { id } });

      return createGivingContentObjectDetail(data);
    },
    queryKey: getGivingDetailQueryKey({ givingId: id, view: 'internal' }),
    ...options,
  });
